<!-- components/Chatbot.vue -->
<template>
    <div class="chatbot-wrapper">
      <!-- Floating AI Launcher Icon (Fixed to bottom-right of page) -->
      <button 
        type="button" 
        class="chatbot-launcher" 
        data-toggle="modal" 
        data-target="#chatbotModal"
        aria-label="Open Chatbot"
      >
        <!-- SVG AI/Bot Icon -->
        <svg xmlns="http://w3.org" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
          <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.74 5.519 5.617a.75.75 0 1 0-.144-1.493C3.53 4.292 2 5.713 2 7.466V8c0 .414.336.75.75.75s.75-.336.75-.75z"/>
          <path d="M1.11 5.045A3.5 3.5 0 0 1 4.5 2h7a3.5 3.5 0 0 1 3.39 3.045 2 2 0 0 1 1.022 1.418 2.25 2.25 0 0 1-.086 1.053 3.5 3.5 0 0 1-1.658 5.143l.415 1.246a.75.75 0 0 1-.95.95l-1.246-.415a3.5 3.5 0 0 1-5.143 1.658 2.25 2.25 0 0 1-1.053.086 2 2 0 0 1-1.418-1.022A3.5 3.5 0 0 1 1.5 12h-.045a2 2 0 0 1-1.418-1.022 2.25 2.25 0 0 1 .086-1.053A3.5 3.5 0 0 1 1.11 5.045M4.5 3A2.5 2.5 0 0 0 2 5.5v5A2.5 2.5 0 0 0 4.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 3z"/>
          <path d="M5.25 6a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 5.25 6m5.5 0a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75"/>
        </svg>
      </button>
  
      <!-- Bootstrap 4 Modal -->
      <div 
        class="modal fade chatbot-modal-container" 
        id="chatbotModal" 
        tabindex="-1" 
        role="dialog" 
        aria-labelledby="chatbotModalLabel" 
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            
            <!-- Modal Header -->
            <div class="modal-header">
              <h5 class="modal-title" id="chatbotModalLabel">Shelta AI Assistant</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
  
            <!-- Modal Body (The Chat Window Layout) -->
            <div class="modal-body chat-window">
              <!-- Message Log -->
              <div class="messages-log" ref="messageLog">
                <!-- :class="['message-bubble', msg.sender]" -->
                <div 
                  v-for="msg in messages" 
                  :key="msg.id" 
                  :class="['message-bubble', msg.role === 'user' ? 'user' : 'bot']"
                >
                  <span class="text">{{ msg.content }}</span>
                </div>
  
                <!-- Loading State Indicator -->
                <div v-if="isLoading" class="message-bubble bot loading">
                  <span>Thinking...</span>
                </div>
              </div>
            </div>
  
            <!-- Modal Footer (Input Area) -->
            <div class="modal-footer input-area">
              <input 
                v-model="userInput" 
                @keyup.enter="sendMessage" 
                placeholder="Ask me anything..." 
                :disabled="isLoading" 
              />
              <button 
                @click="sendMessage" 
                :disabled="isLoading || !userInput.trim()"
                class="send-btn"
              >
                Send
              </button>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    name: 'ChatbotAI',
    data() {
      return {
        userInput: '',
        messages: [
        //   { id: 1, text: 'Hello! How can I help you today?', sender: 'bot' }
             { role: 'assistant', content: `Hello! How can I help you today?` }
        ],
        isLoading: false,
        storedContext: { id: "", first_name: "" },
        userContext: {
            id: "",
            first_name: ""
        },
        userToken: "",
      };
    },
    mounted() {
        this.getUserDetails();
      // Optional Bootstrap hook: Auto-scroll to bottom whenever the modal finishes opening
      /* global $ */
      if (typeof $ !== 'undefined') {
        $('#chatbotModal').on('shown.bs.modal', () => {
          this.scrollToBottom();
        });
      }
    },
    methods: {
        getUserDetails() {
            this.userToken = localStorage.getItem("shelta");
            this.userDetails = localStorage.getItem("shelta-user");
            this.storedContext = { id: "", first_name: "" };
            try {
                const localData = localStorage.getItem('shelta-user');
            if (localData) {
                this.storedContext.id = JSON.parse(localData).id;
                this.storedContext.first_name = JSON.parse(localData).firstname;
            }
            } catch (e) {
            console.error("Failed to get user data:", e);
            }
        },
      async sendMessage() {
        const trimmedInput = this.userInput.trim();
        if (!trimmedInput || this.isLoading) return;
  
        this.messages.push({ 
            role: 'user', 
            content: trimmedInput 
        });
        // this.messages.push({ id: Date.now(), text: trimmedInput, sender: 'user' });
        this.userInput = '';
        this.isLoading = true;
        this.scrollToBottom();
  
        try {
            // const response = await Api.getRequest(`billshistory?page=1&perpage=10`)
          const response = await axios.post('https://ai.myshelta.com/api/chat', { 
                // message: trimmedInput,
                // history: this.messages 
                messages: this.messages, 
                userContext: this.storedContext
            },
            {
                headers: {
                'Authorization': `Bearer ${this.userToken}`,
                'Content-Type': 'application/json'
                }
            }
          );
          console.log("Chat Response", response);
  
          this.messages.push({ 
            role: 'assistant', 
            content: response.data 
          });
        //   this.messages.push({ id: Date.now() + 1, text: response.data.reply, sender: 'bot' });
        } catch (error) {
          console.error("Chatbot API Error:", error);
        //   this.messages.push({ 
        //     id: Date.now() + 1, 
        //     text: "Sorry, I am having trouble sending you any responses right now.", 
        //     sender: 'bot' 
        //   });
        this.messages.push({ 
          role: 'assistant', 
          content: "Sorry, I am having trouble sending you any responses right now." 
        });
        } finally {
          this.isLoading = false;
          this.scrollToBottom();
        }
      },
      scrollToBottom() {
        this.$nextTick(() => {
          const container = this.$refs.messageLog;
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  // Variables Configuration
  $primary-color: #007bff;
  $primary-hover: #0056b3;
  $bot-bubble-bg: #e9ecef;
  $chat-bg: #f9f9f9;
  $border-color: #eee;
  $text-dark: #333;
  $text-muted: #777;
  
  // Floating Launcher Button
  .chatbot-launcher {
    position: fixed;
    bottom: 25px;
    right: 25px;
    z-index: 1050; // Sits comfortably above layout but below open modals
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: $primary-color;
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: transform 0.2s ease, background-color 0.2s ease;
  
    &:hover {
      background-color: $primary-hover;
      transform: scale(1.05);
    }
  
    &:active {
      transform: scale(0.95);
    }
  }
  
  // Bootstrap Modal Overrides & Chat Layout
  .chatbot-modal-container {
    font-family: Arial, sans-serif;
  
    .modal-dialog {
      max-width: 400px; // Standard widget look and feel
    }
  
    .modal-content {
      height: 500px;
      border-radius: 12px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
  
    .modal-header {
      background-color: #fff;
      border-bottom: 1px solid $border-color;
      align-items: center;
    }
  
    .chat-window {
      flex: 1;
      padding: 0; // Removing body padding to let message-log expand seamlessly
      display: flex;
      flex-direction: column;
      overflow: hidden;
  
      .messages-log {
        flex: 1;
        padding: 15px;
        overflow-y: auto;
        background-color: $chat-bg;
        display: flex;
        flex-direction: column;
        gap: 10px;
  
        .message-bubble {
          padding: 10px 14px;
          border-radius: 16px;
          max-width: 80%;
          word-wrap: break-word;
          line-height: 1.4;
          font-size: 14px;
  
          &.user {
            background-color: $primary-color;
            color: white;
            align-self: flex-end;
            border-bottom-right-radius: 4px;
          }
  
          &.bot {
            background-color: $bot-bubble-bg;
            color: $text-dark;
            align-self: flex-start;
            border-bottom-left-radius: 4px;
          }
  
          &.loading {
            font-style: italic;
            color: $text-muted;
          }
        }
      }
    }
  
    .input-area {
      display: flex;
      border-top: 1px solid $border-color;
      padding: 12px;
      background: white;
      justify-content: space-between;
      align-items: center;
  
      input {
        flex: 1;
        padding: 10px 15px;
        border: 1px solid #ddd;
        border-radius: 20px;
        outline: none;
        font-size: 14px;
  
        &:disabled {
          background-color: #f5f5f5;
        }
      }
  
      .send-btn {
        margin-left: 8px;
        padding: 8px 18px;
        background-color: $primary-color;
        color: white;
        border: none;
        border-radius: 20px;
        cursor: pointer;
        font-weight: bold;
        font-size: 14px;
        transition: background-color 0.2s;
  
        &:hover:not(:disabled) {
          background-color: $primary-hover;
        }
  
        &:disabled {
          background-color: #cccccc;
          cursor: not-allowed;
        }
      }
    }
  }
  </style>
  